import type { VoidFunctionComponent } from 'react';

import { emptyConclusionData } from '../../../../../../shared/types/licenses';
import useGetProjectDependency from '../../../../../hooks/api/dependencies/useGetProjectDependency';
import DependencyLicenses from '../../../../projects/dependenciesV2/DependencyDrawer/content/DependencyLicenses/DependencyLicenses';
import type {
  LicenseTabScope,
} from '../../../../projects/dependenciesV2/DependencyDrawer/content/DependencyLicenses/types';

type ProjectLicensesTableProps = {
  dependencyRevisionLocator: string;
  projectId: string;
  revisionId: string;
};

export const ProjectLicensesTable: VoidFunctionComponent<ProjectLicensesTableProps> = ({
  dependencyRevisionLocator,
  projectId,
  revisionId,
}) => {
  const revisionLocator = `${projectId}$${revisionId}`;
  const { data, isLoading } = useGetProjectDependency(revisionLocator, dependencyRevisionLocator, true);

  const licenseTabScope: LicenseTabScope = {
    dependencyRevisionLocator,
    type: 'project',
    projectLocator: projectId,
    revisionLocator,
  };

  const dependency = data?.dependency;

  return (
    <DependencyLicenses
      issues={dependency?.issues || []}
      licenseGroups={dependency?.licenseGroups || []}
      concludedLicenses={dependency?.conclusions || emptyConclusionData}
      scope={licenseTabScope}
      isLoading={isLoading}
      dependency={{
        title: dependency?.title || '',
        version: dependency?.version || '',
        locator: dependency?.locator || '',
      }}
      shouldAllowEditing
    />
  );
};
